import Swal from 'sweetalert2';

// Brand cancel colour used across the app's SweetAlert dialogs.
const CANCEL_COLOR = 'rgb(208 125 63)';

/**
 * Reusable delete-confirmation dialog (SweetAlert2).
 *
 * @param {Object}  options
 * @param {string}  options.title          - Dialog heading. Default: 'Delete?'
 * @param {string}  options.text           - Supporting message / what is being deleted.
 * @param {string} [options.confirmButtonText] - Confirm label. Default: 'Delete'
 * @param {string} [options.cancelButtonText]  - Cancel label.  Default: 'Cancel'
 * @returns {Promise<boolean>} resolves true when the user confirms the delete.
 */
const DeleteSweetAlert = async ({
  title = 'Delete?',
  text = '',
  confirmButtonText = 'Delete',
  cancelButtonText = 'Cancel',
} = {}) => {
  const result = await Swal.fire({
    icon: 'warning',
    title,
    text,
    showCancelButton: true,
    confirmButtonText,
    cancelButtonText,
    confirmButtonColor: '#dc3545',
    cancelButtonColor: CANCEL_COLOR,
    reverseButtons: true,
  });
  return result.isConfirmed;
};

export default DeleteSweetAlert;
